import { instance } from './ApiRequest';
import {GET_ALL_POSTS, GET_ALL_CATEGORY, GET_ALL_UNIVERSITIES, GET_STUDENT_DATA,UPDATE_STUDENT_PERSONAL_DATA, GET_STUDENT_RESERVATION_DATA,
    GET_STUDENT_QUALIFICATION_DATA, UPDATE_STUDENT_RESERVATION_DATA, UPDATE_STUDENT_QUALIFICATION_DATA, GET_STUDENT_IMAGE_DATA, UPLOAD_PROFILE_IMAGE,
    UPLOAD_SIGNATURE_IMAGE,UPLOAD_AADHAAR_IMAGE, UPDATE_STUDENT_IMAGE_DATA, GET_ALL_QUALIFICATION, GET_STUDENT_RECEPT_DATA, GET_STUDENT_PROCESS_STATUS, SUBMIT_STUDENT_FORM,
    DOWNLOAD_STUDENT_EXAM_CARD, GET_ALL_NOTIFICATIONS, UPDATE_STUDENT_NOTIFICATIONS, GET_INITIATE_PAYMENT, VERIFY_PAYMENT,GET_POSTS, GET_POST_DATA,
    GET_PAYMINO_PAYMENT_STATUS, GET_LAST_TRANSACTION, GET_STUDENT_ANSWER_PAPER_PDF_NAME,GET_STUDENT_AKSHEP_DATA_FOR_STUDENT,
    GET_ALL_DISABLE_CATEGORIES,UPLOAD_SCRIBE_IMAGE,
} from 'constants/constants';

let _StudentService = {
    async getStudentPersonalInfo() {
        return await instance.get(GET_STUDENT_DATA);
    },
    async updateStudentPersonalData(body) {
        return await instance.post(UPDATE_STUDENT_PERSONAL_DATA, body);
    },
    async getAllCategory(PostId) {
        return await instance.get(GET_ALL_CATEGORY+ `?PostId=${PostId}`);
    },
    async getStudentReservationData() {
        return await instance.get(GET_STUDENT_RESERVATION_DATA);
    },
    async getStudentQualificationData() {
        return await instance.get(GET_STUDENT_QUALIFICATION_DATA);
    },
    async getAllUniversity() {
        return await instance.get(GET_ALL_UNIVERSITIES);
    },
    async updateStudentReservationData(body) {
        return await instance.post(UPDATE_STUDENT_RESERVATION_DATA, body);
    },
    async updateCandidateQualificationData(body) {
        return await instance.post(UPDATE_STUDENT_QUALIFICATION_DATA, body);
    },
    async getStudentImagesData() {
        return await instance.get(GET_STUDENT_IMAGE_DATA);
    },
    async uploadProfileImage(body) {
        return await instance.post(UPLOAD_PROFILE_IMAGE+"?isUserImage=true", body);
    },
    async uploadSignatureImage(body) {
        return await instance.post(UPLOAD_SIGNATURE_IMAGE+"?isUserImage=false", body);
    },
    async uploadAadhaarImage(body) {
        return await instance.post(UPLOAD_AADHAAR_IMAGE, body);
    },
    async updateStudentImageData(body) {
        return await instance.post(UPDATE_STUDENT_IMAGE_DATA, body);
    },
    async getAllQualification() {
        return await instance.get(GET_ALL_QUALIFICATION);
    },
    async getAllPosts() {
        return await instance.get(GET_ALL_POSTS);
    },
    async getStudentReceiptData() {
        return await instance.get(GET_STUDENT_RECEPT_DATA);
    },
    async getStudentProcessStatus() {
        return await instance.get(GET_STUDENT_PROCESS_STATUS);
    },
    async submitFormData(body) {
        return await instance.post(SUBMIT_STUDENT_FORM, body);
    },
    async UpdateStudentExamCardDownloadFlag(isExamCardDownload) {
        return await instance.get(DOWNLOAD_STUDENT_EXAM_CARD+"?isExamCardDownload=" + isExamCardDownload);
    },
    async getAllNotifications() {
        return await instance.get(GET_ALL_NOTIFICATIONS);
    },
    async updateStudentNotifications() {
        let sid = localStorage["SID"];
        return await instance.post(UPDATE_STUDENT_NOTIFICATIONS+"?studentId=" + sid);
    },
    async GetPost() {
        return await instance.get(GET_POSTS);
    },
    async GetCandidatePostData() {
        return await instance.get(GET_POST_DATA);
    },
    async initiagePaymentRequest() {
        return await instance.get(GET_INITIATE_PAYMENT);
    },
    async verifyPaymentStatus() {
        return await instance.get(GET_PAYMINO_PAYMENT_STATUS);
    },
    async getLastTransaction() {
        return await instance.get(GET_LAST_TRANSACTION);
    },
    async verifyPayment(paymentID) {
        return await instance.get(VERIFY_PAYMENT+"?razorPayPaymentId=" + paymentID);
    },
    async getStudentAnswerPaperPDFName() {
        return await instance.get(GET_STUDENT_ANSWER_PAPER_PDF_NAME);
    },

    //For GetStudentAakshepData

    async GetStudentAakshepDataForStudent() {
        return await instance.get(GET_STUDENT_AKSHEP_DATA_FOR_STUDENT);
    },

    async getAllDisableCategories() {
        return await instance.get(GET_ALL_DISABLE_CATEGORIES);
    },
    async uploadScribeImage(body) {
        return await instance.post(UPLOAD_SCRIBE_IMAGE,body);
    }

   
}

export default _StudentService;